import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResendDiaryMsg } from '../ResendDiaryMsg';


@Component({
  selector: 'app-diary-redend-dialg',
  templateUrl: './diary-redend-dialg.component.html',
  styleUrls: ['./diary-redend-dialg.component.css']
})
export class DiaryRedendDialgComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DiaryRedendDialgComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResendDiaryMsg) { }

  ngOnInit(): void {
  }
  


  
  onNoClick(): void {
    this.dialogRef.close();
  }

}
